<template>
  <ul class="pagination" :class="getClasses(color, size)">
    <li class="page-item" :class="{ disabled: current <= 1 }">
      <a
        class="page-link"
        href="javascript:;"
        aria-label="Previous"
        @click="changePage(current - 1)"
      >
        <i class="fa fa-angle-left"></i>
        <span class="sr-only">Previous</span>
      </a>
    </li>

    <li
      v-for="page in pages"
      :key="page"
      class="page-item"
      :class="{ active: current === page }"
    >
      <a class="page-link" href="javascript:;" @click="changePage(page)">
        {{ page }}
      </a>
    </li>

    <li class="page-item" :class="{ disabled: current >= total }">
      <a
        class="page-link"
        href="javascript:;"
        aria-label="Next"
        @click="changePage(current + 1)"
      >
        <i class="fa fa-angle-right"></i>
        <span class="sr-only">Next</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "SoftPagination",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    pages() {
      // Simple range for now. If total > 10 we might want to truncate, but let's start simple.
      const range = [];
      for (let i = 1; i <= this.total; i++) {
        range.push(i);
      }
      return range;
    },
  },
  methods: {
    getClasses(color, size) {
      let colorValue = color ? `pagination-${color}` : null;
      let sizeValue = size ? `pagination-${size}` : null;
      return `${colorValue} ${sizeValue}`;
    },
    changePage(page) {
      if (page < 1 || page > this.total || page === this.current) return;
      this.$emit("change", page);
    },
  },
};
</script>
